module.exports = __webpack_public_path__ + "img/a2-2.21ff6ef4.png";